const React = require("react");

function HashtagIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M7 20l4-16m2 16l4-16M6 9h14M4 15h14"
  }));
}

module.exports = HashtagIcon;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@heroicons/react/outline/HashtagIcon.js
 ** module id = 541
 ** module chunks = 0
 **/